export const getGoogleTrackingParams = (
  query: Record<string, string>,
  gclid?: string
): { wbraid?: string; gbraid?: string } => {
  if (gclid) return {};

  const wbraid = query.wbraid || undefined;
  const gbraid = query.gbraid || undefined;

  return {
    ...(wbraid && { wbraid }),
    ...(gbraid && { gbraid }),
  };
};
